module.exports = __webpack_public_path__ + "2eb726f6229a8ca216569e007328d6db.png";